<template>
    <div class="image-link">
        <div class="image-link__bg"  :style="'background-image:url('+ bg +');'"></div>
        <div class="image-link__bg__on"  :style="'background-image:url('+ bgOn +');'"></div>
        <div class="image-link__content pa-20 pa-md-30 py-xl-34">
            <v-row no-gutters>
                <v-col cols="auto" :class="'image-link__tit '+titWidth">
                    <h5 class="tit-txt font-weight-bold" data-aos="fade-up">
                        {{tit}}
                    </h5>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <div class="plus"><span></span></div>
                </v-col>
                <v-col cols="12" class="image-link__hidden">
                    <div class="mt-18 mt-xl-24 pt-18 pt-xl-30 border-top border-color-black">
                        <slot/>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

export default{
    props : {
        bg : {type :String, default : ""},
        bgOn : {type :String, default : ""},
        tit : {type :String, default : ""},
        titWidth : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.image-link{
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 100%;
}

.image-link__bg,
.image-link__bg__on,
.image-link__content{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.image-link__bg,
.image-link__bg__on{
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.image-link__bg__on{
    background-color: #fff;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s ease-out;
}

.image-link__tit{
    width: calc(100% - 30px);
}

.plus{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #777;
    display: flex;
    align-items: center;
    justify-items: center;
    opacity: 1;
    visibility: visible;
}

.plus span{
    display: block;
    position: relative;
    width: 12px;
    height: 12px;
    margin: auto;
}

.plus span::before,
.plus span::after{
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #777;
}

.plus span::before{
    width: 2px;
    height: 100%;
}

.plus span::after{
    width: 100%;
    height: 2px;
}

.image-link__hidden{
    opacity: 0;
    visibility: hidden;
}

.image-link:hover .image-link__bg__on{
    opacity: 1;
    visibility: visible;
}

.image-link:hover .image-link__tit{
    width: calc(100% - 30px) !important;
}

.image-link:hover .image-link__tit{
    width: 100% !important;
}

.image-link:hover .plus{
    display: none;
}

.image-link:hover .image-link__hidden{
    opacity: 1;
    visibility: visible;
}
</style>